export const categories = [
  {
    slug: "entertainment",
    name: "娱乐八卦",
    icon: "ri-fire-line",
    count: 128,
    description: "片场花絮、幕后爆料与圈内动态，评论区永远比正片精彩。",
  },
  {
    slug: "screen",
    name: "影视综艺",
    icon: "ri-film-line",
    count: 96,
    description: "剧集选角、综艺剪辑与播出争议，追剧人的观点交锋主战场。",
  },
  {
    slug: "online",
    name: "网络热点",
    icon: "ri-global-line",
    count: 154,
    description: "直播间、短视频与平台规则的争议话题，风向变化最快的一类。",
  },
  {
    slug: "society",
    name: "社会民生",
    icon: "ri-building-2-line",
    count: 87,
    description: "与每个人生活相关的公共讨论，理性围观、观点并列呈现。",
  },
  {
    slug: "game",
    name: "游戏电竞",
    icon: "ri-gamepad-line",
    count: 63,
    description: "抽卡概率、赛事判罚与版本改动，玩家投票最能说明问题。",
  },
  {
    slug: "life",
    name: "生活消费",
    icon: "ri-shopping-bag-3-line",
    count: 72,
    description: "演出退票、订阅规则与消费体验，投票结果一眼看清站队。",
  },
];